import React from 'react';
import './footer-block.scss';

const contacts = [
  {
    phone: '+7 (495) 500-55-50',
    text: 'Телефон для звонков из любой точки мира',
  },
  {
    phone: '900',
    text: 'Бесплатно с мобильного на территории РФ',
  },
];

const FooterBlock = () => {
  return (
    <footer className="footer">
      <div className="footer__wrapper">
        <div className="footer__contacts">
          {contacts.map((el, index) => (
            <div key={index} className="footer__contact">
              <a href={`tel:${el.phone}`} className="footer__contact-phone">{el.phone}</a>
              <div className="footer__contact-text">{el.text}</div>
            </div>
          ))}
        </div>
        <div className="footer__legal">
          На информационном ресурсе применяются&nbsp;
          <a href="https://www.sberbank.ru/privacy/recommtechrules" target="_blank" rel="noopener noreferrer">рекомендательные технологии</a><br /><br />
          ПАО Сбербанк. Генеральная лицензия Банка России на осуществление банковских операций №1481 от 11.08.2015<br /><br />
          © 1997—2024 ПАО Сбербанк. Россия, Москва, 117997, ул. Вавилова, д. 19, тел. +7 (495) 500 5550, 8 800 555 5550.
        </div>
      </div>
    </footer>
  );
};

export default FooterBlock;
